module.exports = __webpack_public_path__ + "img/distributed-lab.dc047dd8.jpg";